module.exports = __webpack_public_path__ + "img/rocket2_w.32eedfcf.svg";